import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var stats = /*#__PURE__*/css("display:flex;flex-wrap:wrap;flex-direction:column;padding-top:5px;", media('>=tablet'), "{flex-direction:row;gap:16px;}");